
import axios from 'axios';
import { useEffect, useRef } from 'react';

import { TabsContent } from '@/components/core/Tabs';
import { getInjector, getRootScope } from '@/services/angularjs-bridge';
import { PersistedItem } from '@/types/DataModel';

import { useItemHierarchies } from '../../hooks/useItemHierarchies';

const ItemHierarchyTab = ({ item, hierarchy }: { item: PersistedItem, hierarchy: string }) => {

    const ref = useRef<HTMLDivElement>(null);

    const $angularJsInjector = getInjector();
    const $rootScope = getRootScope($angularJsInjector);
    const $controller = $angularJsInjector.get('$controller');
    const $compile = $angularJsInjector.get('$compile');
    const $templateCache = $angularJsInjector.get('$templateCache');

    useEffect(() => {

        (async function() {

            if (!ref || !ref.current || !item) {
                return;
            }

            // Prepare a new scope for the hierarchies tab
            const $scope = $rootScope.$new();
            $scope.item = item;
            $scope.currentHierarchy = () => hierarchy;

            // Prepare the tab template
            const templateUrl = 'tpl/editor/hierarchy-tab.tpl.html';
            let $template = $templateCache.get(templateUrl);
            if (!$template) {
                $template = (await axios.get(templateUrl)).data;
                // Let's cache the template for further use in the current session
                $templateCache.put(templateUrl, $template);
            }

            // Prepare the controller
            $controller('EditorItemHierarchyController', {
                $scope: $scope,
                $element: ref.current,
            });

            // Compile the template and attach the $scope to it
            const compileResult = $compile($template)($scope);
            //@ts-ignore
            angular.element(ref.current).append(compileResult);

            $rootScope.$evalAsync();

        })();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [item, ref]);

    return (
        <div ref={ref}></div>
    );
};

const ItemHierarchiesTabs = ({ item }: { item: PersistedItem }) => {

    const { itemHierarchies } = useItemHierarchies(item);

    return (
        itemHierarchies.map(hierarchy =>
            <TabsContent key={hierarchy} value={hierarchy}>
                <ItemHierarchyTab hierarchy={hierarchy} item={item} />
            </TabsContent>
        )
    );
};

export { ItemHierarchiesTabs };
